export class ReturnReason {

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/appraisal/model/return-reason.ts